export default "__VITE_ASSET__DyxBYTER__"